module.exports = __webpack_public_path__ + "static/media/gift_streek.5beed2e2.png";